@if (showSuccessMessage) {
  <div class="text-center">
    <div class="successicon-wrapper">
      <div class="resetsuccessicon">
        <img
          [id]="'verify2faSuccessMessageImage'"
          src="assets/img/brand/success.png"
          alt="success icon"
          height="60px"
        />
      </div>
    </div>
    <h6>
      @if (fromExpiredPasswordFlow) {
        {{ '2fasuccess3' | translate }}
      } @else {
        {{ '2fasuccess2' | translate }}
      }
    </h6>
  </div>
} @else {
  <form
    id="verify2faForm"
    [formGroup]="verify2faFormGroup"
    #verify2faControlForm="ngForm"
    (ngSubmit)="onSubmit()"
    novalidate
    class="text-center"
  >
    <div class="tfa-ccntainer">
      <input
        id="TFAcode"
        name="TFAcode"
        type="text"
        formControlName="TFAcode"
        placeholder="123456"
        required
        inputmode="numeric"
        autocomplete="one-time-code"
        maxlength="6"
        minlength="6"
        class="TFAcode"
        pattern="[0-9]*"
        novatiqAutoFocus
        tabIndex="1"
      />
      @if (hasShowError) {
        <div id="divApiErrorMessage" class="error-message mb-0 mt-1">
          {{ apiError }} <button type="button" class="close themealertclosebtn" (click)="close()">&times;</button>
        </div>
      }
    </div>
    <div class="form-footer w-full">
      <button
        pButton
        pRipple
        class="w-full text-xl"
        id="verifyButton"
        type="submit"
        [disabled]="verify2faControlForm.invalid"
        tabIndex="2"
        label="{{ 'verify' | translate }}"
      ></button>
      <button
        pButton
        pRipple
        class="mt-2 p-button-text w-full text-xl"
        type="button"
        id="CancelButton"
        (click)="cancel()"
        tabIndex="3"
        label="{{ 'cancel' | translate }}"
      ></button>
    </div>
  </form>
}
<ng-template #verify2faForm>
  <form
    id="verify2faForm"
    [formGroup]="verify2faFormGroup"
    #verify2faControlForm="ngForm"
    (ngSubmit)="onSubmit()"
    novalidate
    class="text-center"
  >
    <div class="tfa-ccntainer">
      <input
        id="TFAcode"
        name="TFAcode"
        type="text"
        formControlName="TFAcode"
        placeholder="123456"
        required
        inputmode="numeric"
        autocomplete="one-time-code"
        maxlength="6"
        minlength="6"
        class="TFAcode"
        pattern="[0-9]*"
        novatiqAutoFocus
        tabIndex="1"
      />
      @if (hasShowError) {
        <div id="divApiErrorMessage" class="error-message mb-0 mt-1">
          {{ apiError }} <button type="button" class="close themealertclosebtn" (click)="close()">&times;</button>
        </div>
      }
    </div>
    <div class="form-footer w-full">
      <button
        pButton
        pRipple
        class="w-full text-xl"
        id="verifyButton"
        type="submit"
        [disabled]="verify2faControlForm.invalid"
        tabIndex="2"
        label="{{ 'verify' | translate }}"
      ></button>
      <button
        pButton
        pRipple
        class="mt-2 p-button-text w-full text-xl"
        type="button"
        id="CancelButton"
        (click)="cancel()"
        tabIndex="3"
        label="{{ 'cancel' | translate }}"
      ></button>
    </div>
  </form>
</ng-template>
